module.exports = __webpack_public_path__ + "img/D89E843C-A044-4859-86BD-A388A05DCC3F_1_201_a-min.d398920d.jpeg";